<template>
  <div>
    <span class="pointer"
          :id="`agreement-popover-tgt-${object.id}`"
          @click="load">
      <span :class="object.agreement_signed ? 'text-success' : 'text-danger'">
        {{ object.agreement_signed ? $t('agreement_status_signed') : $t('agreement_status_not_signed') }}
      </span>
      <span v-if="showInfo" class=" ml-1 d-inline-block">
        <InfoSvg class="svg-size-md svg-light"/>
      </span>
    </span>
    <CustomPopover v-if="showInfo"
                   :target="`agreement-popover-tgt-${object.id}`"
                   triggers="click"
                   :arrow="false"
                   placement="bottom">
      <div v-if="loading"
           class="text-muted small">
        <LoadingDots/>
      </div>
      <template v-else>
        <div v-for="(doc, dind) in documents"
             :key="`agreement-doc-${dind}`"
             :class="{ 'mt-2 pt-2 border-top': dind > 0 }">
          <div class="font-weight-bold small">{{ $t(`legal_document_type_${doc.type}`) }}</div>
          <div class="small"
               :class="doc.signed ? 'text-success' : 'text-danger'">
            {{ doc.signed ? $t('agreement_status_signed') : $t('agreement_status_not_signed') }}
          </div>
          <div class="small text-muted">
            {{ $t('version') }} {{ doc.version }}
          </div>
          <div class="small text-muted"
               v-if="doc.signed && doc.accepted_at">
            {{ formatDateTime(doc.accepted_at) }}
          </div>
          <div class="small text-muted"
               v-if="doc.signed && doc.ip">
            IP: {{ doc.ip }}
          </div>
          <a v-if="doc.file_url"
             :href="doc.file_url"
             target="_blank"
             class="text-underlined small d-inline-block mt-1">
            <LinkSvg class="svg-size-sm svg-light mr-1"/>
            {{ $t('open_document') }}
          </a>
        </div>
        <div v-if="!documents.length"
             class="text-muted small">
          {{ $t('no_data_available') }}
        </div>
      </template>
    </CustomPopover>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import CustomPopover from "@/components/parts/calendar/CustomPopover.vue"
import InfoSvg from '@/assets/svg-vue/general/info2.svg'
import LinkSvg from '@/assets/svg-vue/general/link.svg'
import { SuperadminService } from "@/services/api/superadmin.api.service"
import { formatDateTime } from "@/extensions/filters/filters"
import LoadingDots from "@/components/parts/general/LoadingDots.vue"

const props = defineProps({
  object: {
    type: Object
  },
  field: {
    type: Object,
    default: () => ({})
  }
})

const loading = ref(false)
const loaded = ref(false)
const documents = ref([])

const showInfo = computed(() => !!props.object.agreement_signed || !!props.field.multiDocument)

const load = async () => {
  if(loaded.value || loading.value) return
  loading.value = true
  try {
    const res = await SuperadminService.legalAgreementStatus(props.object.id)
    documents.value = res.data?.documents || []
    loaded.value = true
  } catch (e) {
    console.log(e)
  } finally {
    loading.value = false
  }
}
</script>
